import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { compose } from "recompose";
import { connect } from "react-redux";

function LoadingSnackbar({ isLoading, message }) {
    const anchor = { vertical: "top", horizontal: "right" };
    const content = <span>{message}</span>
    const actions = [<CircularProgress key={0} size={24} color="secondary" />]
    return (
        <Snackbar anchorOrigin={anchor} open={isLoading} message={content} action={actions} />
    )
}

const mapState = ({ exploreLoading }) => {
  return {
    isLoading: exploreLoading.isLoading,
    message: exploreLoading.message
  }
};

export default compose(
    connect(mapState)
)(LoadingSnackbar);